import { Injectable, OnDestroy, Type } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InitDialogPayload } from './dialog.model';
import { LoginDialogComponent } from '../../../shared/dialogs/auth/login-dialog/login-dialog.component';
import { RegisterDialogComponent } from '../../../shared/dialogs/auth/register-dialog/register-dialog.component';
import { ForgotPswDialogComponent } from '../../../shared/dialogs/auth/forgot-psw-dialog/forgot-psw-dialog.component';
import { ResetPasswordDialogComponent } from '../../../shared/dialogs/auth/reset-password-dialog/reset-password-dialog.component';
import { AuthErrorDialogComponent } from '../../../shared/dialogs/auth/auth-error-dialog/auth-error-dialog.component';
import { AuthSuccessDialogComponent } from '../../../shared/dialogs/auth/auth-success-dialog/auth-success-dialog.component';
import { DialogActions } from './dialog.actions';
import { AppState } from '../app.state';
import { Store } from '@ngrx/store';
import { AddVehicleFormComponent } from '../../../shared/dialogs/add-vehicle-form/add-vehicle-form.component';
import { VerifyEmailDialogComponent } from './../../../shared/dialogs/auth/verify-email-dialog/verify-email-dialog.component';
import { ApproveDialogComponent } from '../../../shared/dialogs/approve-dialog/approve-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class CustomDialogsService {
  private dialogComponent!: Type<any>;
  constructor(
    private dialogService: DialogService,
    private store: Store<AppState>
  ) {}

  private componentMap: { [key: string]: any } = {
    AddVehicleFormComponent: AddVehicleFormComponent,
    LoginDialogComponent: LoginDialogComponent,
    RegisterDialogComponent: RegisterDialogComponent,
    AuthErrorDialogComponent: AuthErrorDialogComponent,
    AuthSuccessDialogComponent: AuthSuccessDialogComponent,
    ForgotPswDialogComponent: ForgotPswDialogComponent,
    ResetPasswordDialogComponent: ResetPasswordDialogComponent,
    VerifyEmailDialogComponent: VerifyEmailDialogComponent,
    ApproveDialogComponent: ApproveDialogComponent,
  };

  public openDialog(content: InitDialogPayload) {
    this.dialogComponent = this.componentMap[content.componentString];
    const dialogRef = this.dialogService.open(
      this.dialogComponent,
      content.config
    );
    const dialogId = content.dialogId;

    // dialogRef.onClose.subscribe((result: any) => {

    // });

    dialogRef.onDestroy.subscribe((result) => {
      this.closeDialog(dialogId);
    });
  }

  private closeDialog(dialogId: string) {
    this.store.dispatch(DialogActions.closeDialog({ payload: { dialogId } }));
  }
}
